<template>
	<inertia-head title="Member Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Member Home Page!
					</h1>
				</div>
			</div>
		</div>
	</div>

	<div class="content">

		<div class="row g-xxl-5 items-push mb-4">
			<div class="col-lg-8 mb-6">
				<div class="block block-rounded">
					<div class="block-content block-content-full">

						<div v-if="posts.length>0" class="mb-3">
							<inertia-link :href="route('member.community.member-home',{member_name:member.member_name,tab:'overview'})" class="btn btn-outline-info me-2" :class="{'active':tab=='overview'}">Overview</inertia-link>
							<inertia-link :href="route('member.community.member-home',{member_name:member.member_name,tab:'posts'})" class="btn btn-outline-info me-2" :class="{'active':tab=='posts'}">Posts</inertia-link>
							<inertia-link :href="route('member.community.member-home',{member_name:member.member_name,tab:'comments'})" class="btn btn-outline-info" :class="{'active':tab=='comments'}">Comments</inertia-link>
						</div>

						<div v-for="(post,a_index) in postsData" class="block block-rounded bg-transparent mb-0">
							<div class="border border-1 border-light-secondary mb-1"></div>
							
							<div class="block block-rounded bg-transparent ribbon ribbon-left ribbon-bottom mb-0">
								<inertia-link :href="post.postcomment_link" class="block block-rounded block-link-shadow mb-1">
									<div class="block-header">
										<div class="block-title">
											<div class="nav-main-horizontal fw-semibold mb-0">
												<span class="nav-main-item">
													<img v-if="post.community_uuid!=null"
														class="img-avatar img-avatar20 me-1 user-avatar img-avatar-thumb"
														:src="post.community_info.icon_logo"
													/>
													<img v-else
														class="img-avatar img-avatar20 me-1 user-avatar img-avatar-thumb"
														:src="post.member_info.member_logo"
													/>
												</span>
												<span class="nav-main-item">
													<span v-if="post.community_uuid" class="nav-main-horizontal nav-main-hover">
														<span class="nav-main-item">
															<inertia-link data-bs-toggle="submenu" aria-haspopup="true" aria-expanded="false" :href="'/member/community/c/'+post.community_name" class="text-info standard-link me-1">c/{{post.community_name}}</inertia-link> 
															<div class="nav-main-submenu bg-white block block-rounded shadow">
																<div class="block-header p-0 px-3 pt-2">
																	<div class="block-title">
																		<p class="fw-bold m-0 fx-sm">{{post.community_name}}</p>
																	</div>
																</div>
																<div class="block-content p-3 pt-0">
																	<div class="dropdown-divider"></div>
																	<div class="row fs-xs">
																		<div class="col">
																			<div>{{post.community_info.member_total}}</div>
																			<span>Member</span>	
																		</div>
																		<div class="col">
																			<div>{{post.community_info.visit_total}}</div>
																			<span>Views</span>
																		</div>
																	</div>
																</div>
															</div>
															. <span class="fs-xs text-muted fst-italic">{{post.posted_at}}</span>
														</span>
													</span>
													<div v-if="post.community_uuid" class="nav-main-horizontal nav-main-hover">
														<span class="nav-main-item">
															<inertia-link :href="'/member/community/m/'+post.member_info.member_name" class="fs-xs text-muted standard-link">
																{{post.member_info.member_name}}
															</inertia-link>
															<div class="nav-main-submenu bg-white block block-rounded shadow">
																<div class="block-header p-0 px-3 pt-2">
																	<div class="block-title">
																		<p class="fw-bold m-0">{{post.member_info.member_name}}</p>
																		<div class="text-muted fs-xs">m/{{post.member_info.member_name}}</div>
																		<div class="text-muted fs-xs"><i class="fa fa-calendar me-1"></i>{{post.member_info.dateregs}}</div>
																	</div>
																</div>
															</div>
														</span>
													</div>
													<div v-else class="nav-main-horizontal comment-header-member" :class="{'nav-main-hover':post.post_status!='Removed'}">
														<div>
															<div v-if="post.post_status=='Removed'">
																<span class="fs-xs fw-bold text-muted">[DELETED]</span>
															</div>
															<div v-else class="nav-main-item">
																<inertia-link data-bs-toggle="submenu" aria-haspopup="true" aria-expanded="false" :href="'/member/community/m/'+post.member_info.member_name" class="fs-xs text-muted standard-link">m/{{post.member_info.member_name}}</inertia-link> 
																<div class="nav-main-submenu bg-white block block-rounded shadow">
																	<div class="block-header p-0 px-3 pt-2">
																		<div class="block-title">
																			<p class="fw-bold m-0">{{post.member_info.member_name}}</p>
																			<div class="text-muted fs-xs">m/{{post.member_info.member_name}}</div>
																			<div class="text-muted fs-xs"><i class="fa fa-calendar me-1"></i>{{post.member_info.dateregs}}</div>
																		</div>
																	</div>
																</div>
																. <span class="fs-xs text-muted fst-italic">{{post.posted_at}}</span>
															</div>
														</div>
													</div>
												</span>
											</div>
										</div>
									</div>
									<div class="block-content block-content-full pt-0 pb-5">
										<div class="fw-semibold h5 mb-0">{{post.title}}</div>
						                <div class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="post.desc"></div>
									</div>
								</inertia-link>
								<div class="ribbon-box ps-4">
					            	<span class="me-3">
					            		<button @click="votePost(post.community_name,post.post_uuid,'like',post.vote,pIndex)" :disabled="formVotePost.processing && formVotePost.post_uuid==post.post_uuid" type="button" class="btn btn-xs btn-outline-warning rounded-pill" :class="{'active':post.vote==1}">
					            			<div
												v-if="formVotePost.processing && formVotePost.post_uuid==post.post_uuid & formVotePost.vote_label=='like'"
												class="spinner-border spinner-border-sm text-warning"
												role="status"
											>
												<span class="sr-only">Loading...</span>
											</div>
					            			<i v-else class="fa fa-arrow-up"></i>
					            		</button>
					            		<span class="px-1">{{post.vote_total}}</span>
					            		<button @click="votePost(post.community_name,post.post_uuid,'dislike',post.vote,pIndex)" :disabled="formVotePost.processing && formVotePost.post_uuid==post.post_uuid" type="button" class="btn btn-xs btn-outline-danger rounded-pill" :class="{'active':post.vote==-1}">
					            			<div
												v-if="formVotePost.processing && formVotePost.post_uuid==post.post_uuid & formVotePost.vote_label=='dislike'"
												class="spinner-border spinner-border-sm text-danger"
												role="status"
											>
												<span class="sr-only">Loading...</span>
											</div>
					            			<i v-else class="fa fa-arrow-down"></i>
					            		</button>	
					            	</span>
					            	<inertia-link v-if="post.community_uuid!=null" :href="'/member/community/c/'+post.community_name+'/post/'+post.post_uuid+'/'+post.slug_name" class="btn rounded-pill btn-sm btn-alt-secondary" :class="{'active':post.vote==-1}"><i class="fa fa-comment me-1"></i>{{post.comment_total}}</inertia-link>
					            	<inertia-link v-else :href="'/member/community/m/'+post.member_info.member_name+'/post/'+post.post_uuid+'/'+post.slug_name" class="btn rounded-pill btn-sm btn-alt-secondary" :class="{'active':post.vote==-1}"><i class="fa fa-comment me-1"></i>{{post.comment_total}}</inertia-link>
					            </div>
							</div>
						</div>
						
						<div v-if="posts.length<=0" class="text-center">
							<h1 class="display-6 fw-bold text-info">
						        <i class="fa fa-flag me-1 opacity-50"></i>
						        <span>Member's Wall</span>
					     	</h1>
					      	<h3 class="fw-bold mt-5 mb-2">There Are No Posts Yet...</h3>
					      	<h4 class="fw-medium text-muted mb-0">This member is not yet posting on his home page about his/her thoughts, ideas, or experience.</h4>
				      	</div>

					</div>
				</div>

				<div v-if="posts.length>4 && (is_lazy_loading || posts.length==postsData.length)" class="my-3 text-center">
					<span v-if="is_lazy_loading" class="text-info">
						<div
							class="spinner-border spinner-border-sm text-info"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						Loading more...
					</span>
					<div v-else>
						<div
							v-if="is_reloading"
							class="spinner-border spinner-border-lg text-info"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<button v-else @click="reloadPage()" type="button" class="btn btn-xs btn-outline-info">
							<i class="fa fa-refresh me-1"></i>
							Reload the page
						</button>
					</div>
				</div>

			</div>

			<div class="col-lg-4 mb-6 d-none d-sm-table-cell">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="fw-bold mb-2">{{ucWordsName(member.fname+' '+member.lname)}}</div>
					</div>
					<div class="block-content block-content-full border-top border-1">
						<div class="row">
							<div class="col">
								<div class="text-info fw-bold">0</div>
								<span class="fs-xs">Post</span>
							</div>
							<div class="col">
								<div class="text-info fw-bold">0</div>
								<span class="fs-xs">Comment</span>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { debounce } from 'lodash';		
import { watch, onMounted, ref } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';
import { createToaster } from '@meforma/vue-toaster';
import { useForm, usePage } from '@inertiajs/inertia-vue3';
import ContentSlot from './ContentSlot';

export default {
	props:{
		flash 		: Object,
		errors 		: Object,
		tab 		: String,
		member 		: Object,
		posts 		: Object,
	},
	layout: AuthLayout,
	setup(props) {

		const toast = createToaster();

		const is_lazy_loading 	= ref(false);
		const is_reloading 		= ref(false);

		const contentSlot = ref(null);

		var postsData = (props.posts ? props.posts.slice(0,4) : []);
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}


			window.addEventListener(
				'scroll',
				debounce((e) => {
					let body_height = document.body.clientHeight;
            		let end_height = window.scrollY + window.innerHeight;

					if (
						document.body.scrollTop > 20 ||
						document.documentElement.scrollTop > 20
					) {
						// document.getElementById('scroll_top').classList.remove('d-none')
					} else {
						// document.getElementById('scroll_top').classList.add('d-none')
					}

					if(body_height == end_height)
					{
						if(is_lazy_loading.value == false)
						{
							lazyLoad();
						}
					}

				}, 100)
			)
			
		})

		const formReloadPage = useForm({
			reload: true
		});

		const formVotePost = useForm({
			post_uuid 	: null,
			vote_label  : '',
			prev_vote  	: 0,
			vote  		: 0,
			processing 	: false,
		});

		const ucWordsName = (_name)=>{

			return window.ucWordsName(_name);
		}

		const reloadPage = ()=>{
			is_reloading.value = true;

			formReloadPage.post(route('member.community.member-home-reload',{member_name:props.member.member_name}), {
								preserveState: false,
								preserveScroll: false,
								only: ['flash','errors','posts'],
								onSuccess:()=>{
									let new_posts 		= null;

									postsData 			= [];

									is_reloading.value 	= false;

									new_posts 			= (props.posts ? props.posts.slice(0,4) : []);

									postsData.push(new_posts);
									
								},
								onError:()=>{
									is_reloading.value 		= false;
								}
							})

		}

		const lazyLoad = ()=>{
			
			let end_extract = postsData.length + 3;
			let new_posts = props.posts.slice(postsData.length,end_extract);
			
			if(props.posts.length > postsData.length)
			{
				is_lazy_loading.value = true;

				for (var i = 0; i < new_posts.length; i++) {
					postsData.push(new_posts[i]);
				}

				setTimeout(function(){
					is_lazy_loading.value = false;
				},1000);
			}
		}

		const votePost = (_com_name,_post_uuid,_vote_label,_val,_index)=>{

			formVotePost.post_uuid 			= _post_uuid;
			formVotePost.vote_label 		= _vote_label;
			formVotePost.processing 		= true;

			contentSlot.value.votePost(null,_com_name,_post_uuid,_vote_label,_val,_index,'member_posts',(res)=>{
				if(res)
				{
					postsData[_index].vote 			= props.flash.toast.data.vote;
					postsData[_index].vote_total 	= props.flash.toast.data.vote_total;
					postsData[_index].vote_weight 	= props.flash.toast.data.vote_weight;
				}
				formVotePost.reset();
			});

		}


		return{
			ucWordsName,
			is_lazy_loading,
			is_reloading,
			contentSlot,
			postsData,
			formReloadPage,
			reloadPage,
			lazyLoad,
			formVotePost,
			votePost,
		}

	},
}
</script>
